import useContactChangeLock from 'hooks/useContactChangeLock'
import ArrowBtn from 'components/buttons/ArrowBtn'
import useTranslation from 'hooks/useTranslation'
import { useReduxSelector } from 'store'
import { selectConfig } from 'appSlice'
import React from 'react'

const ContactChangeBlocked: React.FC = () => {
  const config = useReduxSelector(selectConfig)
  const { contactSupport } = useContactChangeLock()
  const { t } = useTranslation('form')

  return (
    <div className='popup__form'>
      <p>{t('contactChangeBlocked')}</p>
      {config?.phoneSupport && <h2>
        <a href={`tel:${config.phoneSupport}`}>{config.phoneSupport}</a>
      </h2>}
      <ArrowBtn
        enlarged
        text={t(config?.phoneSupport ? 'callSupport' : 'contactSupport')}
        action={contactSupport} />
    </div>
  )
}

export default ContactChangeBlocked
